<template>
  <section
    :id="`${cms.scroll_id}`"
    v-editable="cms"
    :class="[name]"
    :style="mainCssVars"
  >
    <grid
      :class="['grid--container', `${name}__grid`, `${name}__main`]"
      :layout="[
        {
          size: 1,
          columns: 'repeat(12, 1fr)',
          alignContent: 'center',
          gap: '6px',
        },
        {
          size: 2,
          columns: 'repeat(24, 1fr)',
          gap: '10px',
          alignContent: 'center',
        },
      ]"
    >
      <grid-item
        :class="`${name}__grid-item`"
        :layout="[
          { size: 1, x: 1, width: 12 },
          { size: 3, x: 1, width: 24 },
        ]"
      >
        <component
          :is="item.component"
          v-for="(item, index) in cms.header"
          :key="index"
          v-editable="item"
          :cms="item"
          :class="`${name}__header`"
        />
        <fetch-story
          :route="cms.api_endpoint || ''"
          :params="{
            sort_by: cms.api_order || null,
            by_uuids: cms.api_filter || null,
          }"
          :limit="parseInt(cms.api_limit || 0)"
          :offset="parseInt(cms.api_offset || 0)"
          :collection="cms.collection"
          entry="content"
        >
          <div slot-scope="{ collection }" :class="`${name}__content`">
            <div
              v-for="(item, index) in collection"
              :key="index"
              :class="[`${name}__item`]"
            >
              <component
                :is="item.component"
                v-if="!item.thumbnails"
                v-editable="item"
                :cms="item"
                :url="setCtaUrl(item.cta)"
                :class="`${name}__card`"
                :layout="[
                  { size: 0, bound: 311, ratio: [311, 212] },
                  { size: 1, bound: 425, ratio: [425, 290] },
                  { size: 2, bound: 425, ratio: [425, 290] },
                  { size: 3, bound: 425, ratio: [425, 290] },
                ]"
              />
              <m-card
                v-for="(thumb, t_index) in item.thumbnails"
                :key="t_index"
                v-editable="thumb"
                :cms="{
                  ...thumb,
                  cta: cms.cta,
                  podcast: !!item.component.includes('podcast'),
                }"
                :url="item.url"
                :class="`${name}__card`"
                :layout="[
                  { size: 0, bound: 311, ratio: [311, 212] },
                  { size: 1, bound: 425, ratio: [425, 290] },
                  { size: 2, bound: 425, ratio: [425, 290] },
                  { size: 3, bound: 425, ratio: [425, 290] },
                ]"
              />
            </div>
          </div>
        </fetch-story>
      </grid-item>
    </grid>
  </section>
</template>

<script>
import data from '~/components/organisms/o-list-news/o-list-news-v2.data'
import FetchStory from '~/components/shared/fetch-story'
import MCard from '~/components/molecules/m-cards/m-card'
import MSectionHeaderV2 from '~/components/molecules/m-section-heading/m-section-header-v2'
import Colors from '~/mixins/colors'
export default {
  components: { FetchStory, MSectionHeaderV2, MCard },
  mixins: [Colors],
  props: {
    cms: {
      type: Object,
      default() {
        return Object.assign(process.env.NODE_ENV === 'development' ? data : {})
      },
    },
  },

  data() {
    return {
      name: 'o-list-news-v2',
    }
  },

  computed: {
    mainCssVars() {
      return {
        '--bg-color': this.setColor(
          (this.cms.color_background || {}).color || '#FFFFFF',
          this.cms.color_gradient
        ),
        '--text-color': this.setColor(
          (this.cms.color_text || {}).color || '#000000'
        ),
        '--hover-color': this.setColor(
          (this.cms.color_hover || {}).color || '#C33CA8'
        ),
        '--disabled-color': this.setColor(
          (this.cms.color_disabled || {}).color || '#888b8d'
        ),
        '--spacing-top': this.cms.spacing_top || '100px',
        '--spacing-bottom': this.cms.spacing_bottom || '100px',
      }
    },
  },
  methods: {
    setCtaUrl(cta) {
      for (const item of cta) {
        if (item.href) {
          return (item.href || {}).url || (item.href || {}).cached_url || ''
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.o-list-news-v2 {
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out,
    border 0.2s ease-in-out;
  background-color: var(--bg-color);
  border-color: var(--text-color);
  color: var(--text-color);
  padding: var(--spacing-top) 0 var(--spacing-bottom);

  ::v-deep a,
  ::v-deep .a-cta {
    color: var(--text-color);
    &:disabled,
    &.disabled {
      color: var(--disabled-color);
    }
  }
  ::v-deep a {
    &:hover,
    &:active {
      color: var(--hover-color);
    }
  }
  ::v-deep .a-cta {
    &:hover,
    &:active {
      color: var(--text-color);
    }
  }

  &__main {
    min-height: inherit;
  }

  &__item ::v-deep .m-card {
    padding: 50px 0;
  }

  &__item:last-child ::v-deep .m-card {
    padding-bottom: 0;
  }

  &__content:hover ::v-deep .m-card:not(.over) {
    img {
      filter: grayscale(1);
    }
  }
}

@include media-breakpoint-up(sm) {
  .o-list-news-v2 {
    &__item:not(:last-child) {
      border-bottom: solid 1px;
    }
  }
}
</style>
